import delegate from "delegate-it";
import { scrollTo } from "@/scripts/common/scroll-to";

const handleScroll = (event, el) => {
  let targetSelector = null;

  if (el.dataset.scroll) {
    targetSelector = el.dataset.scroll;
  } else if (el.tagName === "A") {
    targetSelector = el.hash;
  } else {
    return;
  }

  if (targetSelector) {
    const target = document.querySelector(targetSelector);

    if (target) {
      event.preventDefault();

      scrollTo(target);
    }
  }
};

const handleUrl = () => {
  if (window.location.hash) {
    let targetSelector = window.location.hash;

    let target = document.querySelector(targetSelector);

    if (target) {
      history.replaceState(null, "", window.location.pathname + window.location.search);

      document.documentElement.classList.add("is-scrolling");
      window.scrollTo(0, 0);

      const run = () => {
        history.replaceState(null, "", window.location.pathname + window.location.search + targetSelector);

        scrollTo(target);
      };

      if (document.readyState === "complete") {
        run();
      } else {
        window.addEventListener("load", run, { once: true });
      }
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const section = urlParams.get("section");

  if (section) {
    const target = document.querySelector(`#${section}`);

    if (target) {
      document.documentElement.classList.add("is-scrolling");

      setTimeout(() => {
        scrollTo(target);
      }, 125);
    }
  }
};

// Automatically scrolls to the first element with the [data-scrolltome] attribute
const handleScrollToMe = () => {
  const target = document.querySelector("[data-scrolltome]");

  if (target) {
    setTimeout(() => {
      scrollTo(target);
    }, 250);
  }
};

export default {
  init: () => {
    delegate("[data-scroll]", "click", (event) => {
      const el = event.target.closest("[data-scroll]");

      handleScroll(event, el);
    });

    // Handle any custom anchor tags
    delegate(
      '.site-header a[href*="#"]:not(.ignore-scroll), .site-footer a[href*="#"]:not(.ignore-scroll), .wysiwyg a[href*="#"]:not(.ignore-scroll)',
      "click",
      (event) => {
        const el = event.target.closest("a");

        handleScroll(event, el);
      },
    );

    handleUrl();
    handleScrollToMe();
  },
};
